<template>
  <v-layout column align-center justify-start class="relative pt-5">
    <div
      style="width: 100%;height: 130px;background: rgb(234, 234, 234);position: absolute;top: 19px;"
    >
      <v-icon
        style="font-size: 140px;color: rgb(250, 251, 251);position: absolute;right: 9px;bottom: -23px;"
      >shopping_cart</v-icon>
    </div>

    <section class="relative" id="pricing-section">
      <div class="invoice-opt-container">
        <v-layout row justify-start v-if="isUserLoggedIn()">
          <v-icon style="font-size: 57px;color: rgb(204, 198, 198);margin-right: 2px;">receipt</v-icon>
          <div>
            <v-checkbox
              v-model="needInvoice"
              :label="`I want a receipt for my payment`"
              color="grey darken-2"
              style="margin:0px;position:relative;top:11px;"
              class="receipt-checkbox"
              @change="receiptSelectionChanged($event)"
            ></v-checkbox>
          </div>
          <div>
            <a
              flat
              v-if="needInvoice"
              color="primary"
              @click="showBillingDialog"
              style="margin-left: 10px;position: relative;top: 15px;font-size:14px;text-decoration: underline"
            >View billing info</a>
          </div>
        </v-layout>
      </div>

      <v-layout column wrap align-center class="relative" style="z-index:6">
        <v-flex xs12>
          <v-container grid-list-xl class>
            <v-layout row wrap align-center>
              <!--  FREE -->
              <v-card
                class="pricing-container relative"
                style="background:rgb(240, 242, 243) !important"
              >
                <v-card-title primary-title>
                  <v-layout column wrap align-center>
                    <v-icon class="pricing-icon" id="free-plan-icon">directions_run</v-icon>
                    <div class="title mt-2 mb-5">FREE</div>
                    <div class="display-2 pricing-amount" style="background: #85d677;">$0</div>
                    <span class="title pricing-words">100 words</span>
                  </v-layout>
                </v-card-title>
                <v-card-actions>
                  <v-layout
                    column
                    wrap
                    align-center
                    class="mt-5 pt-2 grey--text text--darken-2"
                  >Once on account registration</v-layout>
                </v-card-actions>
              </v-card>

              <!--  BASIC -->
              <v-card class="pricing-container relative">
                <v-card-title primary-title>
                  <v-layout column wrap align-center>
                    <v-icon class="pricing-icon">rowing</v-icon>
                    <div class="title mt-2 mb-5">BASIC</div>
                    <div class="display-2 pricing-amount">$5</div>
                    <span class="title pricing-words">400 words</span>
                  </v-layout>
                </v-card-title>
                <v-card-actions>
                  <v-layout column wrap align-center class="mt-5">
                    <paypal
                      v-if="isUserLoggedIn()"
                      v-on:on-payment-success="success = true"
                      v-on:on-payment-failure="error = true"
                      class="paypalButton"
                      planId="basic"
                      :invoiceable="needInvoice"
                    ></paypal>
                    <v-btn v-else class="elevation-0 pricing-button" @click="login()">Free Trial</v-btn>
                  </v-layout>
                </v-card-actions>
              </v-card>

              <!--  EXTENDED -->
              <v-card class="pricing-container relative">
                <v-card-title primary-title>
                  <v-layout column wrap align-center>
                    <v-icon class="pricing-icon">motorcycle</v-icon>
                    <div class="title mt-2 mb-5">EXTENDED</div>
                    <div class="display-2 pricing-amount relative">$10</div>
                    <span class="title pricing-words">1000 words</span>
                  </v-layout>
                </v-card-title>
                <v-card-actions>
                  <v-layout column wrap align-center class="mt-5">
                    <paypal
                      v-if="isUserLoggedIn()"
                      v-on:on-payment-success="success = true"
                      v-on:on-payment-failure="error = true"
                      class="paypalButton"
                      planId="extended"
                      :invoiceable="needInvoice"
                    ></paypal>
                    <v-btn v-else class="elevation-0 pricing-button" @click="login()">Free Trial</v-btn>
                  </v-layout>
                </v-card-actions>
              </v-card>

              <!--  PREMIUM -->
              <v-card class="pricing-container relative">
                <v-card-title primary-title>
                  <v-layout column wrap align-center>
                    <!--<v-icon>directions_run</v-icon>-->
                    <v-icon class="pricing-icon">flight_takeoff</v-icon>
                    <div class="title mt-2 mb-5">PREMIUM</div>
                    <div class="display-2 pricing-amount relative">$15</div>
                    <span class="title pricing-words">2000 words</span>
                  </v-layout>
                </v-card-title>
                <v-card-actions>
                  <v-layout column wrap align-center class="mt-5">
                    <paypal
                      v-if="isUserLoggedIn()"
                      v-on:on-payment-success="success = true"
                      v-on:on-payment-failure="error = true"
                      class="paypalButton"
                      planId="premium"
                      :invoiceable="needInvoice"
                    ></paypal>
                    <v-btn v-else class="elevation-0 pricing-button" @click="login()">Free Trial</v-btn>
                  </v-layout>
                </v-card-actions>
              </v-card>

              <v-alert v-model="success" dismissible type="success">Successfully paid.</v-alert>
              <v-alert v-model="error" dismissible type="error">An error occurred.</v-alert>
            </v-layout>
          </v-container>
        </v-flex>
      </v-layout>
    </section>

    <v-dialog v-model="billingDialog" width="800" persistent>
      <v-card class="pa-3 pb-1">
        <v-card-title class="headline" primary-title>Your Billing Details</v-card-title>
        <v-card-text>This information will appear on the invoice that you will receive from LingoAV</v-card-text>
        <v-card-text>
          <v-form ref="form">
            <v-container grid-list-xl>
              <v-layout wrap justify-space-between>
                <v-flex xs12 md6>
                  <v-text-field
                    v-model="billingCompanyName"
                    :counter="50"
                    maxlength="50"
                    :rules="requiredField"
                    label="Company"
                    required
                  ></v-text-field>
                  <v-text-field
                    v-model="billingVAT"
                    :counter="30"
                    maxlength="30"
                    :rules="requiredField"
                    label="VAT Number"
                    required
                  ></v-text-field>
                </v-flex>

                <v-flex xs12 md6>
                  <v-text-field
                    v-model="billingAddress"
                    :counter="100"
                    maxlength="100"
                    :rules="requiredField"
                    label="Address"
                    required
                  ></v-text-field>
                  <v-text-field
                    v-model="billingCity"
                    :counter="30"
                    maxlength="30"
                    :rules="requiredField"
                    label="City"
                    required
                  ></v-text-field>
                  <v-text-field
                    v-model="billingState"
                    :counter="20"
                    :rules="requiredField"
                    maxlength="20"
                    label="State/Province/Region"
                  ></v-text-field>
                  <v-text-field
                    v-model="billingZip"
                    :rules="requiredField"
                    :counter="10"
                    maxlength="10"
                    label="ZIP Code"
                  ></v-text-field>
                  <v-autocomplete
                    v-model="billingCountry"
                    label="Country"
                    :items="countries"
                    :rules="requiredField"
                    required
                    filled
                  ></v-autocomplete>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="justify-space-between">
          <v-btn flat @click="billingDialogClosed">Close</v-btn>
          <v-btn color="primary" flat @click="postCustomerInfo">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<style>
.receipt-checkbox label {
  font-size: 14px;
}
</style>
<style scoped>
.invoice-opt-container {
  margin: 0px 13px;
  margin-bottom: 5px;
  min-height: 3.5rem;
}

.invoice-opt-container:hover i {
  text-shadow: 1px 2px 4px #9a9a9a75;
  color: rgb(255, 253, 253) !important;
  transition: color 0.8s;
}

.elevation-0 {
  box-shadow: none !important;
}

.pricing-container {
  width: 275px;
  height: 480px;
  background: white;
  margin: 0px 1px;
  box-shadow: -11px -3px 18px -14px rgba(138, 135, 135, 0.13) !important;
}

.pricing-container-header {
  height: 50px;
  width: 100%;
}

.paypalButton {
  margin: auto;
  width: 70%;
}
</style>

<script>
import paypal from "./PayPal";
import customerBillingInfoService from "../service/customerBillingInfoService";
import { Auth } from "./auth/cognito_auth";

//Consider moving Map

export default {
  name: "lingo_pricing",
  components: {
    paypal
  },
  data: function() {
    return {
      success: false,
      error: false,
      needInvoice: false,
      billingDialog: false,
      requiredField: [v => !!v || "Field is required"],
      billingCompanyName: undefined,
      billingAddress: undefined,
      billingCity: undefined,
      billingState: undefined,
      billingCountry: undefined,
      billingZip: undefined,
      billingVAT: undefined,
      nameRules: undefined,
      valid: undefined,
      rules: undefined,
      countries: this.$store.getters.countries
    };
  },
  mounted: function() {
    if (this.isUserLoggedIn()) {
      this.loadBillingInfo();
    }
  },
  methods: {
    loadBillingInfo() {
      var that = this;
      customerBillingInfoService
        .getCustomerBillingInfoPromise()
        .then(function(response) {
          var customerBillingInfo = response.data;
          that.billingCompanyName = customerBillingInfo.name;
          that.billingAddress = customerBillingInfo.billingAddress;
          that.billingCity = customerBillingInfo.city;
          that.billingState = customerBillingInfo.state;
          that.billingZip = customerBillingInfo.zipCode;
          that.billingVAT = customerBillingInfo.taxId;
          that.billingCountry = customerBillingInfo.country;
        });
    },
    showBillingDialog() {
      var that = this;
      customerBillingInfoService
        .getCustomerBillingInfoPromise()
        .then(function(response) {
          that.billingCompanyName = response.data.name;
          that.billingAddress = response.data.billingAddress;
          that.billingCity = response.data.city;
          that.billingState = response.data.state;
          that.billingZip = response.data.zipCode;
          that.billingVAT = response.data.taxId;
          that.country = response.data.country;
          that.billingDialog = true;
        });
    },
    billingDialogClosed() {
      this.billingDialog = false;
      if (!this.isBillingInfoMaintained()) {
        this.needInvoice = false;
      }
    },
    validate() {
      if (this.$refs.form.validate()) {
        this.billingDialog = false;
      }
    },
    postCustomerInfo() {
      if (this.$refs.form.validate()) {
        this.billingDialog = false;
      } else {
        return;
      }

      var customerBillingInfo = {
        name: this.billingCompanyName,
        billingAddress: this.billingAddress,
        country: this.billingCountry,
        taxId: this.billingVAT,
        zipCode: this.billingZip,
        city: this.billingCity,
        state: this.billingState
      };

      customerBillingInfoService
        .createCustomerBillingInfoPromise(customerBillingInfo)
        .then(
          function(response) {
            if (response.status != 200) {
              alert("Handle error for response status different from 200");
            }
          },
          function(err) {
            alert(err);
          }
        );
    },
    receiptSelectionChanged(event) {
      if (this.needInvoice && !this.isBillingInfoMaintained()) {
        this.showBillingDialog();
      }
    },
    isBillingInfoMaintained() {
      return (
        this.billingVAT &&
        this.billingCompanyName &&
        this.billingAddress &&
        this.billingCity &&
        this.billingCountry
      );
    },
    isUserLoggedIn() {
      return Auth.isUserLoggedIn();
    },
    login: function() {
      Auth.login();
    }
  }
};
</script>